<template>
    <section class="dsp-nearbyschool">
        <div class="panel">
            <div>School data provided by <a class="link f5" href="http://greatschools.org/" rel="nofollow" target="_blank">GreatSchools.org</a></div>
            <div>View more about {{dsp.name}} on <a class="link f5" :href="dsp.allSchoolUrl" rel="nofollow" target="_blank">GreatSchools</a></div>
            <h2 class="h3 text-bold">Nearby Schools</h2>
            <div class="list-card">
                <mvtShifter type="2">
                    <mvtCardSchool  v-for="item in dsp.nearbyschools"  :data="item" :key="item.id"></mvtCardSchool>
                </mvtShifter>
            </div>
            <div class="f7">Source: <a class="link" href="http://greatschools.org/" rel="nofollow" target="_blank">GreatSchools.org</a> © {{new Date().getFullYear()}}. All rights reserved.</div>
            <div class="nearbyLink">
            <a class = "link f5" :href="dsp.schoolSearchUrl"> Find Homes for Sale in {{dsp.name}} School Zone </a>
            </div>
        </div>
    </section>
</template>
<script src="./dsp-nearbyschool.js"></script>
<style lang="scss">
@use "./dsp-nearbyschool.scss" as *;
</style>